'use client';

import { SidebarMenuItem, SidebarMenuButton, useSidebar } from '@ui/components/ui/sidebar';
import { ArrowBigUpDash, Coins } from 'lucide-react';
import Link from 'next/link';
import { useTranslations } from 'next-intl';
import { useUser } from '@/contexts/user-context';

const LOW_ON_CREDITS_THRESHOLD = 200;

function formatCredits(credits: number): string {
  if (credits >= 10000) {
    return `${Math.floor(credits / 1000)}K`;
  }
  if (credits >= 1000) {
    return `${(credits / 1000).toFixed(credits >= 10000 ? 0 : 1)}K`;
  }
  return credits.toString();
}

export default function NavCredits() {
  const t = useTranslations('Navigation');
  const { open } = useSidebar();
  const { creditsRemaining } = useUser();

  const lowOnCredits = creditsRemaining < LOW_ON_CREDITS_THRESHOLD;

  return (
    <>
      <SidebarMenuItem className="pb-1 pointer-events-none" data-tutorial="credits-display">
        <div className="flex items-center justify-center w-full h-8 px-2 text-sm text-center text-muted-foreground">
          <Coins className="mr-2 size-4" />
          <span className="font-bold">{open ? creditsRemaining.toLocaleString() : formatCredits(creditsRemaining)}</span>
          <span className="ml-1 truncate">{t('creditsLeft')}</span>
        </div>
      </SidebarMenuItem>
      <SidebarMenuItem>
        <Link href={'/pricing'}>
          <SidebarMenuButton tooltip={t('getCredits')} variant={lowOnCredits ? 'warning' : 'highlight'} flash={lowOnCredits} size="md" className="">
            <ArrowBigUpDash />
            <span className="flex-1 text-center mr-6">{t('upgradePlan')}</span>
          </SidebarMenuButton>
        </Link>
      </SidebarMenuItem>
    </>
  );
}
